export const routes = {
  form: "/form",
  services: "/services",
  team: "/team",
  objects: "/objects",
  thanks: "/thanks",
};
